<template>
<div>
    <iframe height="100%" width=100% :src="`${getFilePath(fileName)}`" ></iframe>
</div>
</template>

<script>
export default {
  name: 'PDFJSViewer',
  props: {
    propsFileName: {
      type: String,
      required: true
    }
  },
  computed: {
    fileName: {
      get () {
        return this.propsFileName
      }
    }
  },
  methods: {
    getFilePath: (fileName) => {
      console.log('pdf File Name:', fileName)
      if (fileName !== '') {
        return '../../../static/pdfjs/web/viewer.html?file=' + fileName
      }
      return '../../../static/pdfjs/web/viewer.html'
    }
  }
}
</script>
<style scoped>
div {
  width: 100%;
  height: 79vh;
}
</style>



// WEBPACK FOOTER //
// src/components/PdfJsViewer.vue